// FIX #10 — Google Consent Mode v2 default state
// Imposta lo stato 'denied' di default PRIMA che qualsiasi tag Google si carichi.
// Shopify Customer Privacy API propaga poi il consent reale ai Web Pixels (GA4, Google Ads).
// Doc: https://developers.google.com/tag-platform/security/guides/consent
(function consentModeDefault() {
  try {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    if (!window.__consentDefaultSet) {
      gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'granted',
        'wait_for_update': 500,
      });
      gtag('set', 'ads_data_redaction', true);
      gtag('set', 'url_passthrough', true);
      window.__consentDefaultSet = true;
    }
  } catch (e) {}
})();

if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }

      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }

      // GRANULAR CONSENT
      get customizeButton() { return this.querySelector('button[name="customize"]'); }
      get savePreferencesButton() { return this.querySelector('button[name="save_preferences"]'); }
      get backButton() { return this.querySelector('button[name="back"]'); }
      get customizePanel() { return this.querySelector('.cookie__customize-panel'); }
      get buttonsRow() { return this.querySelector('.cookie__flex'); }
      get checkboxAnalytics() { return this.querySelector('input[name="consent_analytics"]'); }
      get checkboxMarketing() { return this.querySelector('input[name="consent_marketing"]'); }
      get checkboxPreferences() { return this.querySelector('input[name="consent_preferences"]'); }

      init() {
        if (this.initialized) return;
        this.initialized = true;

        if (this.testMode) {
          this.load(this.delay);
          return;
        }

        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.1',
          onLoad: this.onConsentLibraryLoaded.bind(this)
        }]);
      }

      load(delay) {
        if (Shopify.designMode) return;

        setTimeout(() => this.show(), delay * 1000);

        if (this.acceptButton) this.acceptButton.addEventListener('click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.declineButton.addEventListener('click', this.declinePolicy.bind(this));

        // GRANULAR CONSENT — handlers
        if (this.customizeButton) this.customizeButton.addEventListener('click', this.openCustomize.bind(this));
        if (this.savePreferencesButton) this.savePreferencesButton.addEventListener('click', this.savePreferences.bind(this));
        if (this.backButton) this.backButton.addEventListener('click', this.closeCustomize.bind(this));
      }

      openCustomize(event) {
        if (event && event.preventDefault) event.preventDefault();
        if (this.customizePanel) this.customizePanel.removeAttribute('hidden');
        if (this.buttonsRow) this.buttonsRow.style.display = 'none';
        // Pre-popola i toggle in base al consent state corrente (se l'utente è tornato)
        try {
          var cur = window.Shopify?.customerPrivacy?.getTrackingConsent && window.Shopify.customerPrivacy.getTrackingConsent();
          if (cur && typeof cur === 'object') {
            if (this.checkboxAnalytics) this.checkboxAnalytics.checked = !!cur.analytics;
            if (this.checkboxMarketing) this.checkboxMarketing.checked = !!cur.marketing;
            if (this.checkboxPreferences) this.checkboxPreferences.checked = !!cur.preferences;
          }
        } catch (e) {}
      }

      closeCustomize(event) {
        if (event && event.preventDefault) event.preventDefault();
        if (this.customizePanel) this.customizePanel.setAttribute('hidden', '');
        if (this.buttonsRow) this.buttonsRow.style.display = '';
      }

      savePreferences(event) {
        if (event && event.preventDefault) event.preventDefault();
        var analyticsOn = !!(this.checkboxAnalytics && this.checkboxAnalytics.checked);
        var marketingOn = !!(this.checkboxMarketing && this.checkboxMarketing.checked);
        var preferencesOn = !!(this.checkboxPreferences && this.checkboxPreferences.checked);

        this.hide();

        // Granular Shopify Customer Privacy API
        try {
          window.Shopify?.customerPrivacy?.setTrackingConsent({
            analytics: analyticsOn,
            marketing: marketingOn,
            preferences: preferencesOn,
            sale_of_data: marketingOn,
          }, this.noop);
        } catch (e) {
          // Fallback: se l'API non accetta oggetto granulare, fallback a binary (true se almeno marketing OR analytics, false altrimenti)
          var anyOn = analyticsOn || marketingOn || preferencesOn;
          window.Shopify?.customerPrivacy?.setTrackingConsent(anyOn, this.noop);
        }

        // Consent Mode v2 update granulare
        try {
          window.dataLayer = window.dataLayer || [];
          function gtag() { window.dataLayer.push(arguments); }
          gtag('consent', 'update', {
            'ad_storage': marketingOn ? 'granted' : 'denied',
            'ad_user_data': marketingOn ? 'granted' : 'denied',
            'ad_personalization': marketingOn ? 'granted' : 'denied',
            'analytics_storage': analyticsOn ? 'granted' : 'denied',
            'functionality_storage': preferencesOn ? 'granted' : 'denied',
            'personalization_storage': preferencesOn ? 'granted' : 'denied',
          });
        } catch (e) {}
      }
    
      acceptPolicy() {
        this.hide();
        window.Shopify.customerPrivacy?.setTrackingConsent(true, this.noop);

        // FIX #10 — Consent Mode v2 update: granted
        try {
          window.dataLayer = window.dataLayer || [];
          function gtag() { window.dataLayer.push(arguments); }
          gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'personalization_storage': 'granted',
          });
        } catch (e) {}

        document.addEventListener('trackingConsentAccepted', () => {
          console.log('trackingConsentAccepted event fired');
        });
      }

      declinePolicy() {
        this.hide();
        window.Shopify.customerPrivacy?.setTrackingConsent(false, this.noop);

        // FIX #10 — Consent Mode v2 update: keep denied (esplicito, per modeling)
        try {
          window.dataLayer = window.dataLayer || [];
          function gtag() { window.dataLayer.push(arguments); }
          gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied',
          });
        } catch (e) {}
      }
    
      onConsentLibraryLoaded() {
        const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
        const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();
    
        if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
          this.load(this.delay);
        }
      }
    
      noop() {
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
